import $ from 'jquery'
import 'bootstrap'
import once from '@drupal/once'
import lightGallery from "lightgallery"
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

if (typeof jQuery === 'undefined') {
  window.jQuery = $
  window.$ = $
}

var $component = once("processed", ".navbar").shift();
if ($component) {
  import("../../templates/component/navbar/js/navbar");
  import("../../templates/component/menu-main/js/menu-main");
}
var $component = once("processed", ".component-jumbotron-default").shift();
if ($component) {
  import("../../templates/component/jumbotron-default/js/jumbotron-default");
}
var $component = once("processed", ".jumbotron-reference").shift();
if ($component) {
  import("../../templates/component/jumbotron-reference/js/jumbotron-reference");
}
var $component = once("processed", ".component-jumbotron-testimonial").shift();
if ($component) {
  import("../../templates/component/jumbotron-testimonial/js/jumbotron-testimonial");
}

// New paragraphs
var $component = once("processed", ".component-jumbotron-slider").shift();
if ($component) {
  import("../../templates/component/jumbotron-slider/js/jumbotron-slider");
}
var $component = once("processed", ".component-hero-testimonial").shift();
if ($component) {
  import("../../templates/component/hero-testimonial/js/hero-testimonial");
}

var $component = once("processed", ".js-lightbox").shift()
if ($component) {
  import("../../templates/component/picture/js/picture")
}
var $component = once('processed-styleguide', '.styleguide').shift();
if ($component) {
  import('../../src/js/styleguide')
}
var $component = once('processed', 'body').shift()
if ($component && typeof ccnstL !== 'undefined') {
  import('../../templates/component/cookieconsent/js/cookieconsent')
}

// Universal gallery
var galleries = document.querySelectorAll('.lightgallery');
galleries.forEach(function (gallery) {
  lightGallery(gallery, {
    thumbnail: true,
    plugins: [lgZoom, lgThumbnail],
    licenseKey: '8C1D605B-6C6F4022-9AE1B332-5383DA54'
  });
})
var galleries = document.querySelectorAll('.lightbox');
galleries.forEach(function (gallery) {
  lightGallery(gallery, {
    selector: 'this',
    licenseKey: '8C1D605B-6C6F4022-9AE1B332-5383DA54'
  });
})

// Navbar
var $navbar = jQuery('.navbar');
$navbar.on('show.bs.collapse','.collapse', function() {
  $navbar.find('.collapse.in').collapse('hide');
});
